// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationOutlinedSvg from "@fishx/icons-svg/es/asn/NotificationOutlined";
import FishxIcon from '../components/FishxIcon';

var NotificationOutlined = function NotificationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationOutlinedSvg
  }));
};

NotificationOutlined.displayName = 'NotificationOutlined';
export default React.forwardRef(NotificationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NotificationOutlined.js
// module id = 3178
// module chunks = 0